import _ from 'lodash';

import domains from '../containers/Domains';
import contextMakePost from './Context';

export const createVideoForAccount = async (data, token) => {
  const parameters = {
    access_token: token,
    file_url: data.file_url
  };

  const id = `act_${data.accountId}/advideos`;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const createVideo = async (data, token) => {
  const parameters = {
    access_token: token,
    published: false,
    file_url: data.file_url
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const createCanvasVideo = async (data, token) => {
  const parameters = {
    access_token: token,
    canvas_video: data.canvas_video
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const getVideosFromPage = async (pageId, token) => {
  const endpoint = `${domains.fbEndpoint}${pageId}/videos`;
  const parameters = {
    access_token: token
  };

  const query = _.template(
    `${endpoint}?access_token=<%= access_token%>&fields=id,updated_time,created_time&limit=1000`
  );
  const result = await fetch(query(parameters));
  return result.json();
};

const getVideos = async (accountId, token) => {
  const endpoint = `${domains.fbEndpoint}act_${accountId}/advideos`;
  const parameters = {
    access_token: token
  };

  const query = _.template(
    `${endpoint}?access_token=<%= access_token%>&limit=100&fields=title,picture`
  );
  const result = await fetch(query(parameters));
  return result.json();
};

export const getVideo = async (videoId, token) => {
  const endpoint = `${domains.fbEndpoint}${videoId}`;
  const parameters = {
    access_token: token
  };

  const query = _.template(
    `${endpoint}?access_token=<%= access_token%>&fields=id,source,picture`
  );
  const result = await fetch(query(parameters));
  return result.json();
};

export const getThumbnailsForVideo = async (videoId, token) => {
  const endpoint = `${domains.fbEndpoint}${videoId}/thumbnails`;
  const parameters = {
    access_token: token
  };

  const query = _.template(`${endpoint}?access_token=<%= access_token%>`);
  const result = await fetch(query(parameters));
  return result.json();
};

export default getVideos;



// WEBPACK FOOTER //
// ./src/fbApi/Videos.js